/* =============================================================================
   Cygnuss Search Enhance - additive JS
   =============================================================================
   - Highlight termo em <mark class="cu-highlight"> nos titulos de produto
   - Empty state amigavel quando 0 resultados
   - localStorage de buscas recentes (max 5 FIFO)
   - Idle state com bestsellers via Section Rendering API
   ============================================================================= */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;
  if (!document.querySelector('predictive-search')) return;

  var STORAGE_KEY = 'cygnuss_recent_searches';
  var MAX_RECENTS = 5;
  var EMPTY_CLASS = 'cu-empty-state';
  var HIGHLIGHT_CLASS = 'cu-highlight';
  var IDLE_CLASS = 'cu-idle';
  var IDLE_SECTION_URL = '/?section_id=cygnuss-bestsellers';

  // Cache do HTML do bestsellers (uma fetch por sessao)
  var bestsellersHTML = null;
  var bestsellersFetching = null;

  // ---- Helpers --------------------------------------------------------------
  function getCurrentQuery(predictiveSearchEl) {
    var input = predictiveSearchEl.querySelector('input[type="search"]');
    return input ? (input.value || '').trim() : '';
  }

  function normalize(str) {
    if (!str) return '';
    return str.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function escapeHTML(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ---- Highlight ------------------------------------------------------------
  function highlightHeadings(root, query) {
    if (!query || query.length < 1) return;
    var nq = normalize(query);
    if (!nq) return;

    var headings = root.querySelectorAll(
      '.predictive-search__item--link-with-thumbnail .predictive-search__item-heading'
    );
    if (!headings.length) return;

    for (var i = 0; i < headings.length; i++) {
      var el = headings[i];
      if (el.querySelector('mark.' + HIGHLIGHT_CLASS)) continue;

      var original = el.textContent || '';
      if (!original) continue;
      var originalNorm = normalize(original);
      if (originalNorm.indexOf(nq) === -1) continue;

      var matches = [];
      var regexRaw;
      try {
        regexRaw = new RegExp(escapeRegExp(query), 'gi');
      } catch (e) {
        continue;
      }
      var m;
      while ((m = regexRaw.exec(original)) !== null) {
        matches.push({ start: m.index, end: m.index + m[0].length, text: m[0] });
        if (m.index === regexRaw.lastIndex) regexRaw.lastIndex++;
      }

      if (!matches.length) {
        var rNorm = new RegExp(escapeRegExp(nq), 'gi');
        var nm;
        while ((nm = rNorm.exec(originalNorm)) !== null) {
          if (nm.index < original.length) {
            matches.push({
              start: nm.index,
              end: nm.index + nm[0].length,
              text: original.substr(nm.index, nm[0].length),
            });
          }
          if (nm.index === rNorm.lastIndex) rNorm.lastIndex++;
        }
      }

      if (!matches.length) continue;

      var newHTML = '';
      var lastIdx = 0;
      for (var j = 0; j < matches.length; j++) {
        var match = matches[j];
        if (match.start < lastIdx) continue;
        newHTML += escapeHTML(original.slice(lastIdx, match.start));
        newHTML += '<mark class="' + HIGHLIGHT_CLASS + '">' + escapeHTML(match.text) + '</mark>';
        lastIdx = match.end;
      }
      newHTML += escapeHTML(original.slice(lastIdx));
      el.innerHTML = newHTML;
    }
  }

  // ---- Empty state ----------------------------------------------------------
  function isEmptyResultsState(resultsRoot, query) {
    if (!resultsRoot || !query || query.length < 1) return false;
    var hasGroups = resultsRoot.querySelector('.predictive-search__results-groups-wrapper');
    if (hasGroups) return false;
    var liveRegion = resultsRoot.querySelector('[data-predictive-search-live-region-count-value]');
    return !!liveRegion;
  }

  function injectEmptyState(resultsRoot, query) {
    if (!resultsRoot) return;
    if (resultsRoot.querySelector('.' + EMPTY_CLASS)) return;

    var safeQuery = escapeHTML(query);
    var icon =
      '<svg class="cu-empty-state__icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="20" cy="20" r="12"></circle>' +
      '<line x1="29" y1="29" x2="40" y2="40"></line>' +
      '<line x1="16" y1="16" x2="24" y2="24"></line>' +
      '<line x1="24" y1="16" x2="16" y2="24"></line>' +
      '</svg>';

    var html =
      '<div class="' + EMPTY_CLASS + '" role="status">' +
      icon +
      '<p class="cu-empty-state__title">No results found for <strong>"' + safeQuery + '"</strong></p>' +
      '<p class="cu-empty-state__hint">Check the spelling or try different terms.</p>' +
      '</div>';

    var firstChild = resultsRoot.firstElementChild;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var node = wrapper.firstElementChild;
    if (firstChild) resultsRoot.insertBefore(node, firstChild);
    else resultsRoot.appendChild(node);
  }

  function removeEmptyStateIfPresent(resultsRoot) {
    if (!resultsRoot) return;
    var existing = resultsRoot.querySelector('.' + EMPTY_CLASS);
    if (existing && existing.parentNode === resultsRoot) {
      existing.parentNode.removeChild(existing);
    }
  }

  // ---- localStorage de recentes --------------------------------------------
  function addRecent(query) {
    if (!query || query.length < 2) return;
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) list = [];
      var nq = query.toLowerCase();
      list = list.filter(function (q) {
        return typeof q === 'string' && q.toLowerCase() !== nq;
      });
      list.unshift(query);
      if (list.length > MAX_RECENTS) list = list.slice(0, MAX_RECENTS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  // ---- Idle state com bestsellers ------------------------------------------
  function fetchBestsellers() {
    if (bestsellersHTML) return Promise.resolve(bestsellersHTML);
    if (bestsellersFetching) return bestsellersFetching;

    bestsellersFetching = fetch(IDLE_SECTION_URL, {
      headers: { Accept: 'text/html' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch failed: ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('#shopify-section-cygnuss-bestsellers');
        var inner = section ? section.innerHTML : '';
        bestsellersHTML = inner;
        return inner;
      })
      .catch(function () {
        bestsellersHTML = '';
        return '';
      })
      .finally(function () {
        bestsellersFetching = null;
      });

    return bestsellersFetching;
  }

  function shouldShowIdle(predictiveSearchEl) {
    var query = getCurrentQuery(predictiveSearchEl);
    if (query.length > 0) return false;
    // Modal aberto: <details-modal><details open>
    var detailsEl = predictiveSearchEl.closest('details');
    if (!detailsEl) return false;
    return detailsEl.hasAttribute('open');
  }

  function getInnerPanel(predictiveSearchEl) {
    return predictiveSearchEl.querySelector('[data-predictive-search]');
  }

  function showIdle(predictiveSearchEl) {
    if (!shouldShowIdle(predictiveSearchEl)) return;
    var panel = getInnerPanel(predictiveSearchEl);
    if (!panel) return;

    // Ja tem idle injetado e visivel: noop
    if (panel.querySelector('.' + IDLE_CLASS)) {
      predictiveSearchEl.setAttribute('open', 'true');
      return;
    }

    // Skeleton enquanto fetcha
    var loadingHTML =
      '<div class="cu-idle cu-idle--loading">' +
      '<div class="cu-idle__skeleton"></div>' +
      '<div class="cu-idle__skeleton"></div>' +
      '<div class="cu-idle__skeleton"></div>' +
      '</div>';

    // Limpa results-groups-wrapper antigo se existir (de busca anterior)
    var oldGroups = panel.querySelector('#predictive-search-results-groups-wrapper');
    if (oldGroups) oldGroups.parentNode.removeChild(oldGroups);

    panel.insertAdjacentHTML('afterbegin', loadingHTML);
    predictiveSearchEl.setAttribute('open', 'true');

    fetchBestsellers().then(function (html) {
      // Reverifica condicao apos fetch (usuario pode ter digitado)
      if (!shouldShowIdle(predictiveSearchEl)) return;

      var loadingNode = panel.querySelector('.cu-idle--loading');
      if (loadingNode) loadingNode.parentNode.removeChild(loadingNode);

      // Idempotencia: se ja tem idle nao-loading, nao re-injeta
      if (panel.querySelector('.cu-idle:not(.cu-idle--loading)')) return;

      if (html) {
        panel.insertAdjacentHTML('afterbegin', html);
      }
    });
  }

  function hideIdle(predictiveSearchEl) {
    var panel = getInnerPanel(predictiveSearchEl);
    if (!panel) return;
    var idle = panel.querySelector('.' + IDLE_CLASS);
    if (idle) idle.parentNode.removeChild(idle);
    var loading = panel.querySelector('.cu-idle--loading');
    if (loading) loading.parentNode.removeChild(loading);
  }

  // ---- Processamento principal ---------------------------------------------
  var rafScheduled = false;
  function scheduleProcess(predictiveSearchEl) {
    if (rafScheduled) return;
    rafScheduled = true;
    (window.requestAnimationFrame || function (fn) { setTimeout(fn, 16); })(function () {
      rafScheduled = false;
      processSearchResults(predictiveSearchEl);
    });
  }

  function processSearchResults(predictiveSearchEl) {
    if (!predictiveSearchEl) return;
    var resultsRoot = predictiveSearchEl.querySelector('#predictive-search-results');
    var query = getCurrentQuery(predictiveSearchEl);

    // Idle state: input vazio + modal aberto
    if (!query) {
      if (resultsRoot) removeEmptyStateIfPresent(resultsRoot);
      // Idle so faz sentido se modal estiver aberto
      if (shouldShowIdle(predictiveSearchEl)) {
        showIdle(predictiveSearchEl);
      }
      return;
    }

    // Tem query: garante que idle esta escondido
    hideIdle(predictiveSearchEl);

    if (!resultsRoot) return;

    var hasGroups = resultsRoot.querySelector('.predictive-search__results-groups-wrapper');
    if (hasGroups) {
      highlightHeadings(resultsRoot, query);
    }

    if (isEmptyResultsState(resultsRoot, query)) {
      injectEmptyState(resultsRoot, query);
    } else {
      removeEmptyStateIfPresent(resultsRoot);
    }
  }

  // ---- Setup ----------------------------------------------------------------
  function attachObserver(predictiveSearchEl) {
    if (predictiveSearchEl.__cuObserved) return;
    predictiveSearchEl.__cuObserved = true;

    // Pre-fetch bestsellers em background (nao bloqueante)
    fetchBestsellers();

    var observer = new MutationObserver(function () {
      scheduleProcess(predictiveSearchEl);
    });
    observer.observe(predictiveSearchEl, { childList: true, subtree: true });

    var input = predictiveSearchEl.querySelector('input[type="search"]');
    if (input) {
      // Iter 5: placeholder mais convidativo (substitui "Pesquisar" do i18n)
      input.setAttribute('placeholder', 'What are you looking for?');
      input.addEventListener('input', function () {
        scheduleProcess(predictiveSearchEl);
      });
      input.addEventListener('focus', function () {
        scheduleProcess(predictiveSearchEl);
      });
    }

    // Modal abre/fecha via <details>: observa toggle
    var detailsEl = predictiveSearchEl.closest('details');
    if (detailsEl) {
      detailsEl.addEventListener('toggle', function () {
        if (detailsEl.hasAttribute('open')) {
          scheduleProcess(predictiveSearchEl);
        } else {
          hideIdle(predictiveSearchEl);
        }
      });
    }

    var form = predictiveSearchEl.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var q = getCurrentQuery(predictiveSearchEl);
        if (q) addRecent(q);
      });
    }
  }

  function init() {
    var elements = document.querySelectorAll('predictive-search');
    for (var i = 0; i < elements.length; i++) {
      attachObserver(elements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ---- DEBUG INSTRUMENTATION (cu-debug) -----------------------------------
  // Activate manually: localStorage.setItem('cu_debug','1') and reload.
  // Auto-disarms after 12s of no activity to keep console clean.
  function cuDebugInit() {
    try {
      var on = false;
      try { on = localStorage.getItem('cu_debug') === '1' || window.CY_SEARCH_DEBUG === true; } catch (e) {}
      if (!on) return;
      var prefix = '[cu-debug]';
      var psList = document.querySelectorAll('predictive-search');
      console.log(prefix, 'init | predictive-search count=' + psList.length);
      psList.forEach(function (ps, idx) {
        var input = ps.querySelector('input[type="search"]');
        var panel = ps.querySelector('.predictive-search[data-predictive-search]') || ps.querySelector('.predictive-search');
        console.log(prefix, 'ps[' + idx + ']', {
          inSearchModal: !!ps.closest('.search-modal'),
          hasInput: !!input,
          hasPanel: !!panel,
          openAttr: ps.hasAttribute('open'),
          loadingAttr: ps.hasAttribute('loading'),
        });
        if (panel) {
          var cs = window.getComputedStyle(panel);
          console.log(prefix, 'ps[' + idx + '] panel style', {
            display: cs.display,
            visibility: cs.visibility,
            position: cs.position,
            top: cs.top,
            left: cs.left,
            width: cs.width,
            height: cs.height,
            zIndex: cs.zIndex,
            overflow: cs.overflow,
            opacity: cs.opacity,
          });
          var rect = panel.getBoundingClientRect();
          console.log(prefix, 'ps[' + idx + '] panel rect', {
            top: rect.top, left: rect.left, w: rect.width, h: rect.height,
            inViewport: rect.top < window.innerHeight && rect.bottom > 0,
          });
        }
        // Watch attribute changes on predictive-search
        var mo = new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            console.log(prefix, 'ps[' + idx + '] mutation', {
              type: m.type,
              attr: m.attributeName,
              oldValue: m.oldValue,
              newValue: m.attributeName ? ps.getAttribute(m.attributeName) : null,
              openNow: ps.hasAttribute('open'),
              loadingNow: ps.hasAttribute('loading'),
            });
            if (panel) {
              var cs2 = window.getComputedStyle(panel);
              console.log(prefix, 'ps[' + idx + '] panel after mut', {
                display: cs2.display, visibility: cs2.visibility, height: cs2.height,
                children: panel.children.length,
                innerHTMLLen: panel.innerHTML.length,
              });
            }
          });
        });
        mo.observe(ps, { attributes: true, attributeOldValue: true });
        // Watch panel for childList (results being injected)
        if (panel) {
          var moPanel = new MutationObserver(function (muts) {
            console.log(prefix, 'ps[' + idx + '] panel childList', {
              count: muts.length,
              firstChild: panel.firstElementChild ? panel.firstElementChild.tagName + '.' + panel.firstElementChild.className : null,
              children: panel.children.length,
            });
          });
          moPanel.observe(panel, { childList: true });
        }
        // Watch input for typing
        if (input) {
          input.addEventListener('input', function () {
            console.log(prefix, 'ps[' + idx + '] input', {
              value: input.value,
              openAttr: ps.hasAttribute('open'),
              loadingAttr: ps.hasAttribute('loading'),
            });
          });
          input.addEventListener('focus', function () {
            console.log(prefix, 'ps[' + idx + '] focus', {
              value: input.value,
              openAttr: ps.hasAttribute('open'),
            });
          });
        }
        // Auto-disarm after 12s
        setTimeout(function () {
          mo.disconnect();
          console.log(prefix, 'ps[' + idx + '] disarmed');
        }, 12000);
      });
    } catch (e) {
      console.warn('[cu-debug] error', e);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cuDebugInit);
  } else {
    setTimeout(cuDebugInit, 100);
  }
})();

/* =============================================================================
   Cygnuss DEBUG: lock the header search modal open (for screenshots).
   Activate with ?cu_search_lock=1 in the URL (or localStorage cu_search_lock=1).
   Inert otherwise. Remove the param to unlock. Re-opens instantly if something
   tries to close it, so any print/snip tool captures it open.
   ============================================================================= */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  var on = false;
  try {
    on = new URLSearchParams(window.location.search).has('cu_search_lock') ||
         localStorage.getItem('cu_search_lock') === '1';
  } catch (e) {}
  if (!on) return;
  function start() {
    var all = document.querySelectorAll('.header__search');
    var target = null;
    for (var i = 0; i < all.length; i++) {
      try {
        if (getComputedStyle(all[i]).display !== 'none' && all[i].getBoundingClientRect().width > 0) {
          target = all[i]; break;
        }
      } catch (e) {}
    }
    target = target || all[0];
    if (!target) return;
    var details = target.querySelector('details');
    if (!details) return;
    try {
      var s = target.querySelector('summary');
      if (s && !details.hasAttribute('open')) s.click();
    } catch (e) {}
    var obs = new MutationObserver(function () {
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    });
    obs.observe(details, { attributes: true, attributeFilter: ['open'] });
    try { console.log('[cu] search modal LOCKED open (cu_search_lock). Remove ?cu_search_lock from URL to unlock.'); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 350); });
  } else {
    setTimeout(start, 350);
  }
})();